import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "w-full border border-gray-lp-1500 rounded-xl p-4",
  "data-testid": "pickup-detail-section-stt"
}
const _hoisted_2 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Title, {
        label: _ctx.$t('pickup.detail.stt.sectionTitle'),
        bold: "bold",
        "font-color": "text-black-lp-300"
      }, null, 8, ["label"])
    ]),
    (_ctx.listStt.length > 0)
      ? (_openBlock(), _createBlock(_component_TableV2, {
          key: 0,
          data: _ctx.listStt,
          columns: _ctx.columns,
          pagination: _ctx.pagination,
          "is-hard-pagination": true,
          "border-top": true,
          "border-bottom": true,
          "is-quick-search": false,
          "is-sorting": false,
          "hide-pagination": false,
          "is-show-pagination": _ctx.listStt.length > 0,
          "is-space-top": false,
          "is-space-bottom": false,
          "is-pinned-scroll-bottom": false,
          "is-no-padding-bottom": true,
          bgHeader: 'white',
          "pagination-style": "v2",
          "custom-class-pagination": "relative w-full",
          loading: _ctx.loading
        }, null, 8, ["data", "columns", "pagination", "is-show-pagination", "loading"]))
      : _createCommentVNode("", true),
    (_ctx.listStt.length === 0)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 1,
          "data-testid": "pickup-detail-stt-table-empty-state",
          customHeaderMessage: _ctx.$t('pickup.detail.stt.emptyTitle')
        }, null, 8, ["customHeaderMessage"]))
      : _createCommentVNode("", true)
  ]))
}